/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Permission } from '@gh/core-auth';
import { FormState } from '../form-state';

export abstract class ApplicationState {
  abstract currentForm?: FormState<any>;

  abstract hasPermission(permission: Permission): boolean;
}

export interface ApplicationStateHolder {
  readonly state: ApplicationState;
}

export abstract class ApplicationStateFactory {
  abstract createByForm(state: FormState<any>): ApplicationState;
}

export type ApplicationStatePredicate = PredicateFn<ApplicationState>;

// tslint:disable:max-line-length
export type ApplicationStatePredicateSet =
  boolean
  | ApplicationStatePredicate
  | (boolean | ApplicationStatePredicate)[];

export interface ApplicationStateValidator {
  validate(predicateSet: ApplicationStatePredicate): boolean;
}
